import { render, staticRenderFns } from "./IzyCard.vue?vue&type=template&id=3ca9dacd&scoped=true"
import script from "./IzyCard.vue?vue&type=script&lang=js"
export * from "./IzyCard.vue?vue&type=script&lang=js"
import style0 from "./IzyCard.vue?vue&type=style&index=0&id=3ca9dacd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca9dacd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VAvatar,VCard,VImg})
